/* global G */
import { showBlockingDialog } from 'app/_shared/events/dialog'
import PlatformError from 'lib/util/error'
import { setKey } from 'lib/util'
import back from 'app/_shared/hook/redirect/back'

const descriptor = 'hook:onlineCheck'

const defaultTitleOptions = {
  ns: 'common',
  key: 'dialog.error.offline.item.title',
  defaultValue: 'Sorry',
}

const defaultTextOptions = {
  ns: 'common',
  key: 'dialog.error.offline.item.text',
  defaultValue: 'You cannot create/edit this object when offline.',
}

/**
 * Online Check Hook
 *
 * Shows a dialog and throws an error if the application is offline.
 *
 * @param {DialogOptions} [options] dialog options
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const onlineCheck = ({ title: titleOptions, text: textOptions } = {}) => obj => async (...args) => {
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]
  const online = obj[G.ADAPTER][G.SESSION][G.STATE][G.ONLINE]

  if (!online) {
    const title = titleOptions?.key ? titleOptions : defaultTitleOptions
    const text = textOptions?.key ? textOptions : defaultTextOptions
    const error = { name: 'StateError', message: 'Application is offline' }

    setKey(null, G.ROUTE, obj[G.STATE])
    await showBlockingDialog(obj, actionComponent, { title, text, cancel: false })
    await back(obj)(args)
    throw new PlatformError(obj, descriptor, error)
  }

  return args
}

export default onlineCheck
